import {createAsyncThunk,  createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: null,
  data : null,
  isAgreementAccepted : null,
  isTrail : null,
  isTrailWebApp : null,
  availableTrailDays: null,
  isSubscriptionShow : null,
  trailDetails : null,
  planDetails : null,
  isPlanExist : null,
  planName: null,
  planStatus: null
};

export const storeLimit = createAsyncThunk(
  "storeLimit",
  async (storeHash) => {
    try {
      const response = await fetch(`/api/getstorelimit?storeHash=${storeHash}`, {
        method: "GET",
      });
      if (!response.ok) {
        throw new Error("Failed to fetch config");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message);
    }
  }
);

const credentialsSlice = createSlice({
  name: "storeLimit",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(storeLimit.pending, (state) => {
        state.status = "PIM loading";
        state.message = null;
      })
      .addCase(storeLimit.fulfilled, (state, action) => {
        state.status = "PIM loaded";

        const rawData = action?.payload?.data?.data;

        // Parse if response is string
        const response =
          typeof rawData === "string"
            ? JSON.parse(rawData)
            : rawData;

        state.data = response;

        state.isAgreementAccepted =
          response?.agreementAcceptedFlag ?? false;

        state.isTrail = typeof response?.remainingTrialDays === 'number' && response?.remainingTrialDays > 0 ? true : false;

        state.isTrailWebApp = typeof response?.currentPlanType === 'string' && response?.currentPlanType === "TRIAL" ? true : false;

        state.trailDetails =
          response?.trialPlanInfo ?? null;

        state.isSubscriptionShow = typeof response?.subscriptionPageDisplayFlag === 'boolean' && response?.subscriptionPageDisplayFlag === true ? true : false;

        state.availableTrailDays = response?.remainingTrialDays === 'number' ? response?.remainingTrialDays : 0;

        state.isPlanExist = !!response?.paidPlanInfo;

        state.planDetails =
          response?.paidPlanInfo ?? null;

        state.planName = response?.paidPlanInfo?.name;

        state.planStatus = response?.paidPlanInfo?.status;

      })
      .addCase(storeLimit.rejected, (state, action) => {
        state.status = "error";
        state.message = action.error.message;
      });
  },
});

export default credentialsSlice.reducer;
